export const AUDIO_SPEEDS = [0.8, 1, 1.2] as const;
export type AudioSpeed = (typeof AUDIO_SPEEDS)[number];

export const SOLO_AUDIO_SPEED_KEY = 'ld.solo.audioSpeed';

export function isAudioSpeed(value: number): value is AudioSpeed {
  return AUDIO_SPEEDS.some((speed) => speed === value);
}

export function readAudioSpeed(value: string | null): AudioSpeed {
  if (value === null) return 1;
  const parsed = Number(value);
  return isAudioSpeed(parsed) ? parsed : 1;
}
